import request from '@/utils/request2'

// 列表(主数据列表)
export function loadWeChatContactListDataApi(data) {
  return request({
    url: 'tms-web/weChatContact/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportWeChatContactListDataApi(data) {
  return request({
    url: 'tms-web/weChatContact/exportByPage',
    method: 'post',
    data
  })
}

// 待匹配问卷用户的微信联系人分页列表
export function loadToMatchContactListDataApi(data) {
  return request({
    url: 'tms-web/weChatContact/listToMatchByPage',
    method: 'post',
    data
  })
}

// 获取待匹配问卷用户的微信联系人数量
export function countToMatchContactApi(data) {
  return request({
    url: 'tms-web/weChatContact/countToMatch',
    method: 'post',
    data
  })
}

// 可关联小程序用户或零售户档案的微信联系人分页列表
export function loadAbleRelateContactListDataApi(data) {
  return request({
    url: 'tms-web/weChatContact/listAbleRelateByPage',
    method: 'post',
    data
  })
}

// 可关联小程序用户或零售户档案的微信联系人数量
export function countAbleRelateContactApi(data) {
  return request({
    url: 'tms-web/weChatContact/countAbleRelate',
    method: 'post',
    data
  })
}

// 匹配问卷用户
export function matchQuestionnaireUserApi(data) {
  return request({
    url: 'tms-web/weChatContact/matchQuestionnaireUser',
    method: 'post',
    data
  })
}

// 排除问卷用户
export function excludeQuestionnaireUserApi(data) {
  return request({
    url: 'tms-web/weChatContact/excludeQuestionnaireUser',
    method: 'post',
    data
  })
}

// 取消匹配问卷用户
export function cancelMatchQuestionnaireUserApi(data) {
  return request({
    url: 'tms-web/weChatContact/cancelMatchQuestionnaireUser',
    method: 'post',
    data
  })
}

// 认证零售户档案
export function connectStoreWeChatContactApi(data) {
  return request({
    url: 'tms-web/weChatContact/connectStore',
    method: 'post',
    data
  })
}

// 关联小程序用户
export function connectAppUserWeChatContactApi(data) {
  return request({
    url: 'tms-web/weChatContact/connectAppUser',
    method: 'post',
    data
  })
}

// 取消认证零售户档案
export function cancelConnectStoreWeChatContactApi(data) {
  return request({
    url: 'tms-web/weChatContact/cancelConnectStore',
    method: 'post',
    data
  })
}

// 取消关联小程序用户
export function cancelConnectAppUserWeChatContactApi(data) {
  return request({
    url: 'tms-web/weChatContact/cancelConnectAppUser',
    method: 'post',
    data
  })
}

// 查看
export function viewWeChatContactApi(data) {
  return request({
    url: 'tms-web/weChatContact/view',
    method: 'post',
    data
  })
}

// 列表
export function listWeChatContactApi(data) {
  return request({
    url: 'tms-web/weChatContact/list',
    method: 'post',
    data
  })
}
